<template>
    <div>
        <template v-if="collection_transaction_history === true">
            <div>
                <!--
                <div class="row mb-3">
                    <div class="col-md-12">
                        <div class="row top-widgets-row align-bottom">
                            <div class="col-md-4 widgets-col">
                                <div class="payroll-counter-box">
                                    <div class="top-box no-bg">
                                        <span class="title" title="7"> <em class="rollover"> {{formatAmount(total_payment_recevied)}} </em> </span>
                                        <p> Payment Recieved </p>
                                    </div>
                                    <div class="foot-box"></div>
                                </div>
                            </div>
                            <div class="col-md-4 widgets-col">
                                <div class="payroll-counter-box">
                                    <div class="top-box no-bg">
                                        <span class="title" title="7"> <em class="rollover"> {{formatAmount(total_transfered)}} </em> </span>
                                        <p> Transfered </p>
                                    </div>
                                    <div class="foot-box"></div>
                                </div>
                            </div>
                            <div class="col-md-4 widgets-col">
                                <div class="payroll-counter-box">
                                    <div class="top-box no-bg">
                                        <span class="title" title="250000k"> {{formatAmount(total_balance)}} </span>
                                        <p> Balance </p>
                                    </div>
                                    <div class="foot-box"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                -->
                <div class="page-top mb-1 mb-3 clearfix">
                    <div class="page-top float-left">
                        <h1 class="m-0">Collection Balance: <span class="highlight-color"> (PKR {{formatAmount(total_payment_recevied)}})</span> </h1>
                    </div>
                    <template v-if="corporate_account_management_permission === true && collection_settlement_permission === true">
                        <div class="page-top float-right" >
                            <div class="col"><button class="btn btn-primary proceed active" @click="showAutoSettlementPopup">Collection Settlement</button></div>
                        </div>
                    </template>
                </div>
                <div class="corporate-main">
                    <div class="corporate-head pb-3 clearfix">
                        <h3 class="transaction-history-head float-left"> Collection History </h3>
                        <div class="dt-buttons" id="buttons" v-show="ledger.length > 0">
                            <a _target="_blank" class="dt-button buttons-excel buttons-html5" tabindex="0" aria-controls="newTab" href="#"  id="downloadExcel" @click="downloadExcel()" ><span><span class="fa fa-file-excel-o"></span>Export</span></a>
                            <a _target="_blank" class="dt-button buttons-excel buttons-html5" tabindex="0" aria-controls="newTab" href="#"  id="printTransactions" @click="printTransactions()" ><span><span class="fa fa-file-excel-o"></span>Print</span></a>
                        </div>
                        <div class="searching float-right">
                            <input id="custom_search" type="text" class="form-control search" autocomplete="off" />
                        </div>
                    </div>
                    <table id="dt-table" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>TXN ID</th>
                                <th>Transaction Type</th>
                                <th>Description</th>
                                <th>Debit</th>
                                <th>Credit</th>
                                <th>Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(transaction, index) in ledger" v-bind:value="transaction.id" v-bind:key="index">
                                <td>{{transaction.date | date_format}}</td>
                                <td>{{transaction.transaction_id}}</td>
                                <td>{{transaction.type}}</td>
                                <td>{{transaction.text}}</td>
                                <td v-if="transaction.type === 'DEBIT'">{{transaction.amount}}</td>
                                <td v-else>--</td>
                                <td v-if="transaction.type === 'CREDIT'">{{transaction.amount}}</td>
                                <td v-else>---</td>
                                <td>{{transaction.running_balance}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
        <template v-else-if="collection_transaction_history === null"><preLoader></preLoader></template>
        <template v-else-if="collection_transaction_history === false">
            <notAllowed></notAllowed>
        </template>

        <template>
            <!-- Before-Auto-Settlement Modal -->
            <div class="modal fade" id="show_auto_settlement_popup" tabindex="-1" role="dialog" aria-labelledby="showAutoSettlementPopup" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close" @click="as_data_loaded = false">
                            <span>×</span>
                        </button>
                        <div class="modal-body collections-settlement-popup p-4" v-if="as_data_loaded === true">
                            <h2 class="mt-4 mb-3"> You can settle your Collections-Balance into your Virtual-Account </h2>
                            <div class="account-settlement-content">
                                <div class="content-row">
                                    <div class="content-col"> <p> Virtual Account Balance: </p> </div>
                                    <div class="content-col settlement-amount"> <p> PKR {{ formatAmount(as_total_va_balance) }}/- </p> </div>
                                </div>
                                <div class="content-row">
                                    <div class="content-col"> <p> Current Collection Balance: </p> </div>
                                    <div class="content-col settlement-amount"> <p> PKR {{ formatAmount(as_total_collection_balance) }}/- </p> </div>
                                </div>
                                <div class="content-row">
                                    <div class="content-col"> <p> Usable Collection Balance: </p> </div>
                                    <div class="content-col settlement-amount"> <p> PKR {{ formatAmount(as_usable_collection_balance) }}/- </p> </div>
                                </div>
                            </div>
                            <div class="settlement-field mt-4">
                                <div class="form-group">
                                    <input type="text" name="amount" class="form-control number-field" v-model="as_amount_to_settle" @keypress="isNumber($event)"/>
                                    <button class="btn btn-primary active" @click="settlementConfirmation" :disabled="as_usable_collection_balance <= 0 || as_amount_to_settle <= 0 || parseInt(as_amount_to_settle) > parseInt(as_usable_collection_balance)"> Settle Now </button>
                                </div>
                            </div>
                        </div>
                        <preLoader v-else></preLoader>
                    </div>
                </div>
            </div>
            <!-- Before-Auto-Settlement Modal -->

            <!-- Auto-Settlement-Confirmation Modal -->
            <div class="modal fade" id="show_auto_settlement_confirmation_popup" tabindex="-1" role="dialog" aria-labelledby="showAutoSettlementConfirmationPopup" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content" >
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>×</span>
                        </button>
                        <div class="modal-body collections-settlement-popup p-4">
                            <h2 class="mt-4 mb-3"> Are you sure that you want to settle PKR {{ formatAmount(as_amount_to_settle) }}/- into your Virtual Account {{as_company_va_number}}</h2>
                            <div class="form-group align-center">
                                <button class="btn btn-primary confirmation-btns active" @click="autoSettlementFormSubmit"> Yes</button>
                                <button class="btn btn-primary confirmation-btns" @click="hideAutoSettlementConfirmationPopup"> No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Auto-Settlement-Confirmation Modal -->


            <!-- Auto-Settlement-Result Modal -->
            <div class="modal fade" id="show_auto_settlement_result_popup" tabindex="-1" role="dialog" aria-labelledby="showAutoSettlementResultPopup" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close" @click="as_data_loaded = false">
                            <span>×</span>
                        </button>
                        <div class="modal-body collections-settlement-popup p-4" v-if="as_data_loaded === true">
                            <div class="success-col align-center">
                                <img src="/images/confirmation-tick.png" width="60" alt="" />
                                <h2 class="mt-2 mb-3 cust-settle-color" > Settlement Successfull.</h2>
                                <h2 class="mt-2 mb-3"> Balance will be updated shortly ! </h2>
                            </div>
                        </div>
                        <preLoader v-else></preLoader>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                ledger : [],
                total_payment_recevied: null,
                total_transfered: null,
                total_balance: null,
                collection_transaction_history: null,
                collection_settlement_permission: null,
                corporate_account_management_permission: null,
                as_company_va_number : null, // prefix-as stands for auto-settlement
                as_total_va_balance : null,
                as_total_collection_balance : null,
                as_usable_collection_balance : null,
                as_data_loaded : false,
                as_amount_to_settle : 0,
            };
        },
        methods: {
            downloadExcel(){
                $('#downloadExcel').css('pointer-events','none')
                axios.get('/api/downloadCollectionTransactionExcel',{
                    responseType: 'blob'
                })
                .then((response) => {
                     $('#downloadExcel').css('pointer-events','')
                    if(response.status == 200){
                         const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/vnd.ms-excel'
                        }))

                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download','collection_history.xlsx')
                        document.body.appendChild(link)
                        link.click()
                        this.$Progress.finish();
                    }else{
                        this.showAlertBox('error','There is some problem');
                    }

                }).catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },
            printTransactions(){
                $('#printTransactions').css('pointer-events','none');
                axios.get('/api/CollectionTransactionPrint')
                .then((response) => {
                $('#printTransactions').css('pointer-events','');
                    if(response.status == 200){
                        var mywindow = window.open('', 'PRINT', 'height=400,width=600');
                        mywindow.document.write(response.data);
                        mywindow.document.close(); // necessary for IE >= 10
                        mywindow.focus(); // necessary for IE >= 10*/
                        mywindow.print();
                        mywindow.close();
                        return true;
                    }else{
                        this.showAlertBox('error','There is some problem');
                    }

                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },
            getCollectionHistoryData(){
                axios.post("/api/collectionTransactionhistory")
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.total_payment_recevied = res.data.collection_balance;
                            this.ledger = res.data.ledger;
                        }else{
                            this.showAlertBox('error','System is not responding! Please try again later.');
                        }
                    }else{
                        this.showAlertBox('error','System is not responding! Please try again later.');
                    }
                })
                .then(res => {
                    this.callDataTable();
                })
                .catch(err => {
                    console.log(err);
                    this.showAlertBox('error','System is not responding! Please try again later.');
                });
            },
            callDataTable(){
                var dataTable = $("#dt-table").dataTable({
                    "sDom": '<"row view-pager"<"col-sm-12 highlight-color pb-2 text-right"i">><"table-holder transaction-history mb-3"t><"col-sm-12 text-center"p">r',
                    "paging":true,
                    "pageLength":100,
                    "searching":true,
                    "order":false,
                    buttons: [],
                });
                $('#custom_search').on( 'keyup', function () {
                    dataTable.fnFilter(this.value);
                });
            },
            getCollectionAutoSettlementData : function(type){
                this.as_data_loaded = false;

                axios.get("/api/getCollectionAutoSettlementData")
                .then(res => {
                    if(res.data.status == 200)
                    {
                        this.as_data_loaded               = true;
                        this.as_company_va_number         = res.data.data.company_va_number; // prefix-as stands for auto-settlement
                        this.as_total_va_balance          = res.data.data.total_va_balance;
                        this.as_total_collection_balance  = res.data.data.total_collection_balance;
                        this.as_usable_collection_balance = res.data.data.usable_collection_balance;
                    }
                    else
                    {
                        this.hideAutoSettlementPopup();

                        this.as_company_va_number         = null;
                        this.as_total_va_balance          = 0;
                        this.as_total_collection_balance  = 0;
                        this.as_usable_collection_balance = 0;

                        this.showAlertBox('error', res.data.msg);
                    }
                })
                .catch(err => {
                    
                    this.hideAutoSettlementPopup();

                    this.as_company_va_number         = null;
                    this.as_total_va_balance          = 0;
                    this.as_total_collection_balance  = 0;
                    this.as_usable_collection_balance = 0;

                    this.showAlertBox('error','There is some problem !!');
                });
            },
            showAutoSettlementPopup : function(){
                this.getCollectionAutoSettlementData();
                $("#show_auto_settlement_popup").modal('show');
            },
            hideAutoSettlementPopup : function(){
                this.as_data_loaded = false;
                $("#show_auto_settlement_popup").modal('hide');
            },
            showAutoSettlementConfirmationPopup : function(){
                $("#show_auto_settlement_confirmation_popup").modal('show');
            },
            hideAutoSettlementConfirmationPopup : function(){
                $("#show_auto_settlement_confirmation_popup").modal('hide');
            },
            showAutoSettlementResultPopup : function(){
                $("#show_auto_settlement_result_popup").modal('show');
            },
            hideAutoSettlementResultPopup : function(){
                $("#show_auto_settlement_result_popup").modal('hide');
            },
            settlementConfirmation: function(){
                this.hideAutoSettlementPopup();
                this.showAutoSettlementConfirmationPopup();
            },
            autoSettlementFormSubmit: function(){

                this.as_data_loaded = false;
                this.hideAutoSettlementConfirmationPopup();
                this.showAutoSettlementResultPopup();

                if(this.as_amount_to_settle > this.as_usable_collection_balance)
                {
                    this.as_data_loaded = true;
                    this.hideAutoSettlementResultPopup();

                    swal.fire({
                        title: 'You cannot settle more than your current-balance',
                        type: 'error',
                    });

                    return false;
                }

                axios.post('/api/autoSettleCollectionBalance', {'amount' : this.as_amount_to_settle})
                .then(res => {
                    if(res.data.status == 200)
                    {
                        this.as_data_loaded = true;
                    }
                    else
                    {
                        this.as_data_loaded = true;
                        this.hideAutoSettlementResultPopup();
                        this.showAlertBox('error', res.data.msg);
                    }
                })
                .catch(err => {
                    this.as_data_loaded = true;
                    this.hideAutoSettlementResultPopup();
                    this.showAlertBox('error','There is some problem ..');
                });
            },
        },
        mounted() {
			this.can('collection|corporate_account_management|collection_settlement').then(result => {
                this.collection_transaction_history = result.collection;
                this.account_balance = result.vr_balance;
                this.corporate_account_management_permission = result.corporate_account_management;
                this.collection_settlement_permission = result.collection_settlement;
            }).then(result => {
                if(this.collection_transaction_history == true){
					this.getCollectionHistoryData();
                }
            });

        },
    }
</script>
